import type { Action } from './actions'
import type { ApplicationDataDTO, AppSettingsDTO } from 'shared/types/api'

export type State = ApplicationDataDTO & AppSettingsDTO

const initialState: State = {
    header: [],
    footer: [],
    copyright: '',
    googleApiKey: '',
    orbEnabled: false,
    appInsertEnabled: false,
    appInsertCloseTime: 15,
    appInsertViewCloseTime: 90,
    pointsPerEuroClickAndCollect: 0,
    pointsPerEuroDeliveryInApp: 0,
    pointsPerEuroTableOrder: 0,
    secondsBeforeOrderDelivered: 0,
    couponInsertWeb: {
        backgroundImageWebDesk: '',
        backgroundImageWebMob: ''
    }
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'APP_SETTINGS_RESPONSE':
        case 'APPLICATION_DATA_RESPONSE':
            return {
                ...state,
                ...action.data
            }
        default:
            return state
    }
}
